export type CategorySubCategoryRow = {
  description: string;
  icon: string;
  id: number;
  name: string;
  parentCategory: unknown;
  categoryId: number;
  status?: boolean;
  childCount: number;
};

/** Map GET category/{id} → subcategory rows for the nested table. */
export const mapSubCategoriesForTable = (
  subCategories: unknown,
  parentCategoryId: number
): CategorySubCategoryRow[] => {
  if (!Array.isArray(subCategories)) {
    return [];
  }

  return subCategories.map((entry) => ({
    description: entry?.description || "",
    icon: entry?.icon || "",
    id: entry?.id,
    name: entry?.name || "",
    parentCategory: entry?.parentCategory ?? null,
    categoryId: parentCategoryId,
    status: entry?.status,
    childCount: entry?.children?.length || 0,
  }));
};

/** Read sub_category_count from GET category/main item. */
export const getSubCategoryCount = (category: Record<string, unknown>): number => {
  const count = category?.sub_category_count ?? category?.subCategoryCount;
  return typeof count === "number" ? count : Number(count) || 0;
};
